import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../utils/reduxHelper.js";

export const recommendedCollectionsReduxAPI = createApi({
  reducerPath: "recommendedCollectionsReduxAPI",
  baseQuery: baseQueryWithArgs,

  endpoints: (builder) => ({
    //GET Queries
    getRecommendedCollectionsTags: builder.query({
      query: () => getQueryStringWithCreator(`c/getRecommendedCollectionsTags`),
    }),
    getRecommendedCollectionById: builder.query({
      query: ({ id }) =>
        getQueryStringWithCreator(`c/getRecommendedCollectionById?id=${id}`),
    }),

    // POST Queries
    getRecommendedCollections: builder.mutation({
      query: (body) => ({
        url: `c/getRecommendedCollections`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    getRecommendedProductWishlink: builder.mutation({
      query: (body) => ({
        url: `c/getRecommendedProductWishlink`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    convertRecommendedCollection: builder.mutation({
      query: (body) => ({
        url: `c/convertRecommendedCollection`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetRecommendedCollectionsTagsQuery,
  useGetRecommendedCollectionsMutation,
  useLazyGetRecommendedCollectionByIdQuery,
  useGetRecommendedProductWishlinkMutation,
  useConvertRecommendedCollectionMutation,
} = recommendedCollectionsReduxAPI;
